import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>© 2026 Milan Ahuja.</p>
    </footer>
  );
}

export default Footer;
